export { default } from './Typography';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/core/esm/Typography/index.js
// module id = 24
// module chunks = 0